module.exports = __webpack_public_path__ + "img/resell-giab.128c13c6.png";